import { Link } from "react-router-dom";
import type { Post } from "@/types/content";

export default function RelatedPosts({ items }: { items: Post[] }) {
  if (items.length === 0) return null;

  return (
    <section aria-labelledby="related-title" className="mt-12">
      <h2
        id="related-title"
        className="font-heading text-xl font-black text-foreground-950 md:text-2xl"
      >
        相关推荐
      </h2>
      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {items.map((post) => (
          <Link
            key={post.id}
            to={`/post/${post.id}`}
            className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
          >
            <span className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
              <span className="rounded-md bg-accent-100 px-2 py-0.5 text-accent-900">
                {post.school}
              </span>
              <span>{post.createdAt}</span>
            </span>
            <h3 className="mt-2.5 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-[15px]">
              {post.title}
            </h3>
            <span className="mt-3 flex items-center gap-3 border-t border-background-200 pt-3 text-xs text-foreground-500">
              <span className="flex items-center gap-1 text-primary-600">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-thumb-up-line"></i>
                </span>
                {post.likes}
              </span>
              <span className="flex items-center gap-1">
                <span className="flex h-3.5 w-3.5 items-center justify-center">
                  <i className="ri-chat-3-line"></i>
                </span>
                {post.comments}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}